import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { ArrowDown } from "lucide-react";

function fmtNum(v) {
  if (v === null || v === undefined) return "—";
  return Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 });
}

function fmtPrice(v) {
  if (v === null || v === undefined) return "—";
  return `$${Number(v).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  })}`;
}

export default function LosersTable({ losers, onRowClick }) {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="border-white/10 hover:bg-transparent">
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 w-[110px]">
              Ticker
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
              Company
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 hidden md:table-cell">
              Sector
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 text-right">
              Prev
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 text-right">
              Close
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 text-right">
              Change %
            </TableHead>
            <TableHead className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 text-right hidden sm:table-cell">
              Volume
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {losers.map((l, i) => (
            <TableRow
              key={l.ticker}
              data-testid={`stock-row-${l.ticker}`}
              onClick={() => onRowClick?.(l)}
              className="row-fade border-white/5 cursor-pointer hover:bg-zinc-800/60"
              style={{ animationDelay: `${Math.min(i * 30, 300)}ms` }}
            >
              <TableCell className="font-mono font-semibold text-zinc-50">
                {l.ticker}
              </TableCell>
              <TableCell className="text-sm text-zinc-200 max-w-[220px] truncate">
                {l.company_name || <span className="text-zinc-500">—</span>}
              </TableCell>
              <TableCell className="text-xs font-mono text-zinc-400 hidden md:table-cell">
                {l.sector || "—"}
              </TableCell>
              <TableCell className="font-mono text-right text-zinc-300 tabular-nums">
                {fmtPrice(l.prev_close)}
              </TableCell>
              <TableCell className="font-mono text-right text-zinc-100 tabular-nums">
                {fmtPrice(l.close_price)}
              </TableCell>
              <TableCell className="text-right">
                <span className="inline-flex items-center gap-1 rounded-md bg-[#FF3B30]/15 text-[#FF6B62] font-mono px-2 py-1 text-xs tabular-nums">
                  <ArrowDown className="h-3 w-3" />
                  {l.change_pct.toFixed(2)}%
                </span>
              </TableCell>
              <TableCell className="font-mono text-right text-zinc-400 tabular-nums hidden sm:table-cell">
                {fmtNum(l.volume)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
